module.exports = __webpack_public_path__ + "media/images/hn-4-352bf862.jpg";